import React, { useEffect, useState } from 'react';
import { useSetRecoilState } from 'recoil';
import { SelectValue } from 'antd/es/select';

import { alertsSelectorAdd } from '../../recoil';
import { LARGE_PAGE_SIZE } from '../../constants';
import { defaultApi } from '../../apis';
import { ConnectorApiKeyAuthTypeEnum, ConnectorModel, ConnectorOAuth2AuthTypeEnum } from '../../../gamma-api';
import IbSelect from '../common/IbSelect';
import IbButton from '../common/IbButton';
import ConnectorsModal from '../ConnectorsModal';
import IbIcon from '../common/IbIcon';
import { getTranslateFunc } from '../../utils/stringUtil';
import { fixObjectId } from '../../utils/idUtils';

import './index.less';

import { MAIN_CLASS_NAME } from './const';

export interface IConnectorBlockProps {
  connectorId: string;
  authType?: ConnectorApiKeyAuthTypeEnum | ConnectorOAuth2AuthTypeEnum;
  onChange?: (connector_id: string) => void;
  onBlur?: () => void;
}

const ConnectorBlock: React.FC<IConnectorBlockProps> = ({ connectorId, authType, onChange, onBlur }) => {
  const addAlert = useSetRecoilState(alertsSelectorAdd);

  const [connectorsSelectLoading, setConnectorsSelectLoading] = useState(true);
  const [connectorsModalVisible, setConnectorsModalVisible] = useState(false);

  const [connectors, setConnectors] = useState<ConnectorModel[]>([]);

  const translate = getTranslateFunc('Connector: Block:');

  const loadConnectors = async () => {
    setConnectorsSelectLoading(true);

    try {
      const response = await defaultApi.searchConnectors(
        0,
        LARGE_PAGE_SIZE,
        false,
        undefined,
        undefined,
        undefined,
        authType ? [authType] : undefined
      );
      setConnectors(response.data.items || []);
    } catch (err) {
      addAlert({
        content: translate('Failed to load'),
        type: 'error',
      });
      // eslint-disable-next-line no-console
      console.error(err);
    }

    setConnectorsSelectLoading(false);
  };

  const onInitLoad = () => {
    loadConnectors().finally();
  };
  useEffect(onInitLoad, [authType]);

  const onConnectorChange = (value: SelectValue) => {
    onChange?.(value as string);
  };

  const onSetupConnectorsClick = () => {
    setConnectorsModalVisible(true);
  };

  const onConnectorsModalClose = async () => {
    setConnectorsModalVisible(false);
    await loadConnectors();
  };

  const connectorOptions = connectors.map((connector) => ({
    value: connector.connector_id,
    label: `${connector.name} - ${connector.settings.apis.web.url}`,
  }));

  return (
    <div className={MAIN_CLASS_NAME}>
      <IbSelect
        loading={connectorsSelectLoading}
        options={connectorOptions}
        value={fixObjectId(connectorId)}
        onBlur={onBlur}
        onChange={onConnectorChange}
      />
      <IbButton icon={<IbIcon iconName="setting-two" />} type="link" onClick={onSetupConnectorsClick}>
        {translate('Setup')}
      </IbButton>
      <ConnectorsModal visible={connectorsModalVisible} onClose={onConnectorsModalClose} />
    </div>
  );
};

export default ConnectorBlock;
